<template>
  <div>
    <div class="form_radio">
      <input
        :id="values"
        type="radio"
        name="radio"
        :value="values"
        v-model="syncSelected"
      />
      <label :for="values">{{ label }}</label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sm-radio',
  components: {},
  props: {
    label: {
      type: String
    },
    values: {
      type: String
    },
    value: {
      type: String
    },
    selected: {
      type: String
    }
  },
  computed: {
    syncSelected: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  setup() {}
}
</script>

<style lang="scss" scoped>
@import 'style';
</style>
